import { createFileRoute } from '@tanstack/react-router'
import { OnboardingWizard } from '@/components/onboarding/wizard/OnboardingWizard'

export const Route = createFileRoute('/onboarding/organization/$group/$step')({
  component: OnboardingWizardStepRoute,
})

function OnboardingWizardStepRoute() {
  const { group, step } = Route.useParams()
  return <OnboardingWizard group={group} step={step} />
}
